<template>
  <template v-if="populatedForm?.fields">
    <mpf-form
      :form-title="populatedForm.config?.formTitle"
      :hint="populatedForm.config?.hint"
      :fields="populatedForm?.fields"
      @submit="(e) => handleSubmit(e)"
      submit-label="Continue"
    />
  </template>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { router } from '../../router';
  import { MpfFormPropsWithConfig } from '../../types/router-meta';
  import { useRouteMeta } from '../composables/useRouteMeta';
  import MpfForm from '../components/MpfForm/MpfForm.vue';
  import { useMedicalRequestStore } from '../../stores/useMedicalRequestStore';
  import { useMergeDataIntoForm } from '../composables/useMergeDataIntoForm';
  import { useUrlSegments } from '../composables/useUrlSegments';
  import { useAdminRequestStore } from '../../stores/useAdminRequestStore';
  import { RequestType } from '../../types';
  import { useRequestFormAvailability } from '../composables/useRequestFormAvailability';

  const { formConfig } = useRouteMeta<MpfFormPropsWithConfig>();
  const { firstSegment } = useUrlSegments();
  const { check } = useRequestFormAvailability();

  const medicalRequestStore = useMedicalRequestStore();
  const adminRequestStore = useAdminRequestStore();

  const handleSubmit = async (data: any) => {
    const formStatus = await check(firstSegment.value as RequestType);
    if (!formStatus) return;

    if (firstSegment.value === 'medical-request') {
      medicalRequestStore.setProxyDetails(data.values);
    } else if (firstSegment.value === 'admin-request') {
      adminRequestStore.setProxyDetails(data.values);
    } else if (firstSegment.value === 'repeat-prescription-request') {
      // NOOP repeatPrescriptionRequestStore.setProxyDetails(data.values);
    }

    if (data.valid) {
      await router.push(`/${firstSegment.value}/patient-details`);
    }
  };

  const { mergeDataIntoForm } = useMergeDataIntoForm();

  const populatedForm = computed(() => {
    const config = formConfig.value as MpfFormPropsWithConfig | undefined;
    if (!config) return null;
    return mergeDataIntoForm(config, `${firstSegment.value}`, 'proxyDetails') ?? config;
  });
</script>
